package us.laantech.common.dto

import kotlinx.serialization.Serializable
import us.laantech.common.util.generateUUIDv7

@Serializable
data class PriceLog(
    val priceCents: Long,
    val createdAt: Long
)

@Serializable
data class RetailProductDTO(
    val accountSub: String? = null,
    val uuid: String = generateUUIDv7(),
    val branchUuid: String? = null,
    val parentCompanyUuid: String? = null,
    val departmentUUID: String? = null,

    // who
    val ageLimit: Int? = null,
    // what
    val brand: String? = null,
    val title: String? = null,
    val barcode: String? = null,
    val imageUrl: String? = null,
    val imageUrls: List<String>? = null,
    // how
    val taxable: Boolean? = true,
    val ebt: Boolean? = false,
    val refundable: Boolean? = true,
    val priceCents: Long? = null,
    val priceLog: List<PriceLog>? = null, // TODO

    // Metadata
    val createdAt: Long? = null,
    val updatedAt: Long? = null,
    val userSku: String? = null,
    val userPrice: Long? = null,

    // Inventory
    // TODO when transaciton is finalized, update inventory count
//    val inventory: InventoryDTO? = null,
    val inventoryLog: List<InventoryDTO>? = listOf(),

    // TODO price history and inventory log needs to be excluded from reciept

    ) {

    // TODO get price from price history
    val priceCentsTODO: PriceLog? = priceLog?.maxByOrNull{ it.priceCents }

    val inventory: InventoryDTO? get() = inventoryLog?.maxByOrNull { it.createdAt ?: 0L }

    init {
        ageLimit?.let {
            require(it in 0..120) {
                "Age limit must be between 0 and 120"
            }
        }
//        require(upc == null || upc.length == 12) {
//            "UPC must be 12 digits long"
//        }
    }

    fun getTotalInventoryIn(): Long {
        val count = inventory?.addedCount ?: 0L
        return count
    }

    fun getTotalInventoryOut(): Long {
        val count = inventoryLog?.sumOf {
            it.soldCount
                ?.plus(it.damagedCount ?: 0L)
                ?.plus(it.writeOffCount ?: 0L)
                ?.plus(it.lostCount ?: 0L)
                ?.plus(it.storeUseCount ?: 0L)
                ?.plus(it.expiredCount ?: 0L)
                ?: 0L
        } ?: 0L

        return count
    }

    fun netInventory(): Long {
        return getTotalInventoryIn() - getTotalInventoryOut()
    }


}

